export default __webpack_public_path__ + "protected-area-800-8c4c0be8e0ecfceae5aa6525c80e0180.webp";